import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";

export const ReviewBadge = ({ title, rating = 4.8, count = "12K", platform = "Google Reviews", className = "", idSuffix = "" }) => {
  const [hover, setHover] = useState(0);
  const [rated, setRated] = useState(0);
  const full = Math.round(Number(rating) || 0);
  return (
    <div data-testid={`review-badge${idSuffix}`} className={`w-[16.5rem] rounded-2xl border border-white/15 bg-black/55 backdrop-blur-xl p-4 shadow-2xl shadow-black/40 ${className}`}>
      <div className="flex items-center gap-2">
        <span className="grid h-7 w-7 place-items-center rounded-full bg-white text-[15px] font-extrabold leading-none">
          <span style={{ background: "conic-gradient(from -45deg,#ea4335,#fbbc05,#34a853,#4285f4,#ea4335)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>G</span>
        </span>
        <span className="text-xs font-semibold text-slate-200">{platform}</span>
        <span className="ml-auto text-[10px] font-bold uppercase tracking-wider text-[#F9CF04]">Verified</span>
      </div>

      <div className="mt-3 flex items-end gap-3">
        <div className="font-display text-4xl font-extrabold leading-none text-white" data-testid={`review-rating-value${idSuffix}`}>{(Number(rating) || 0).toFixed(1)}</div>
        <div>
          <div className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className={`h-4 w-4 ${i <= full ? "fill-[#F9CF04] text-[#F9CF04]" : "text-slate-600"}`} />
            ))}
          </div>
          <div className="text-[11px] text-slate-400 mt-1" data-testid={`review-count${idSuffix}`}>reviewed by {count} people</div>
        </div>
      </div>

      {title && <div className="mt-2 text-sm font-semibold text-[#F9CF04]" data-testid={`review-title${idSuffix}`}>{title}</div>}

      <div className="mt-3 border-t border-white/10 pt-3">
        <div className="text-[11px] text-slate-400 mb-1">Enjoyed it? Rate us</div>
        <div className="flex gap-1" data-testid={`review-rate-stars${idSuffix}`}>
          {[1, 2, 3, 4, 5].map((i) => (
            <button key={i} type="button" onMouseEnter={() => setHover(i)} onMouseLeave={() => setHover(0)}
              onClick={() => { setRated(i); toast.success("Thanks for rating us! 🙌"); }}
              data-testid={`rate-star-${i}${idSuffix}`} aria-label={`Rate ${i} star`} className="p-0.5">
              <Star className={`h-5 w-5 transition-colors ${i <= (hover || rated) ? "fill-[#F9CF04] text-[#F9CF04]" : "text-slate-500 hover:text-[#F9CF04]"}`} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
